import React from "react";
import { Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import vendorStore from "../../redux/store";

const VendorPortalLayout = () => {
  return (
    <Provider store={vendorStore}>
      {/* This will render the nested vendor routes */}
      <Outlet />
    </Provider>
  );
};

export default VendorPortalLayout;
